import { css } from 'styled-components';

// Scrollbar discreta no estilo X (Twitter) — fina, semitransparente,
// sem setas, cor adapta ao tema.
//
// AVISO: desde commit do scrollbar global em global-style.js, esse
// mixin se tornou OPCIONAL — todo elemento scrollavel ja recebe esse
// visual via `*::-webkit-scrollbar*`. Mantemos o mixin pra:
//   1. Opt-in EXPLICITO quando voce quer documentar intencao no styled
//   2. Override em casos onde uma lib injeta scrollbar diferente
//   3. Garantia futura caso alguem remova o global
//
// Match com global-style (8px / 4px radius / 18%-35% opacity).
export const discreteScrollbar = css`
  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: ${(props) =>
      props.theme.title === 'light'
        ? 'rgba(0, 0, 0, 0.18)'
        : 'rgba(255, 255, 255, 0.18)'}
    transparent;

  /* WebKit */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background-color: ${(props) =>
      props.theme.title === 'light'
        ? 'rgba(0, 0, 0, 0.18)'
        : 'rgba(255, 255, 255, 0.18)'};
    border-radius: 4px;
    border: 2px solid transparent;
    background-clip: content-box;
    transition: background-color 150ms ease;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: ${(props) =>
      props.theme.title === 'light'
        ? 'rgba(0, 0, 0, 0.35)'
        : 'rgba(255, 255, 255, 0.35)'};
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
`;
